import { render, staticRenderFns } from "./ShirtDetail.vue?vue&type=template&id=8aa14bf6&scoped=true"
import script from "./ShirtDetail.vue?vue&type=script&lang=js"
export * from "./ShirtDetail.vue?vue&type=script&lang=js"
import style0 from "./ShirtDetail.vue?vue&type=style&index=0&id=8aa14bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa14bf6",
  null
  
)

export default component.exports